import React from 'react';
import { List } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import AvatarSmall from '../../common/AvatarSmall';
import User from './user';

export default (notification, index) => (
    <List.Item key={index}>
        <AvatarSmall id={notification.actor_id} name={notification.actor_name} />
        <List.Content>
            <List.Description>
                <Link to={`/networkFeed/user/${notification.actor_id}`}>{notification.actor_name}</Link> joined Mappes{' '}
            </List.Description>
        </List.Content>
    </List.Item>
);
 